import { useState, type FormEvent } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { getCategories } from '@/utils/video';

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const categories = getCategories();

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : '/search');
    setMenuOpen(false);
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="sticky top-0 z-50 w-full bg-primary-900/95 backdrop-blur-md border-b border-primary-800">
      <div className="w-full px-4 md:px-6">
        <div className="flex h-16 items-center gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer" onClick={closeMenu}>
            <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-accent-500 text-primary-950">
              <i className="ri-play-circle-fill text-2xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="text-lg font-bold text-background-50 tracking-wide">宅男视频</span>
              <span className="text-[10px] text-primary-200 tracking-widest">ZHAINAN.TV</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1 ml-4">
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                `px-3 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                  isActive ? 'text-accent-400' : 'text-primary-100 hover:text-background-50 hover:bg-primary-800'
                }`
              }
            >
              首页
            </NavLink>
            {categories.map((cat) => (
              <NavLink
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                    isActive ? 'text-accent-400' : 'text-primary-100 hover:text-background-50 hover:bg-primary-800'
                  }`
                }
              >
                {cat.name}
              </NavLink>
            ))}
            <NavLink
              to="/about"
              className={({ isActive }) =>
                `px-3 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                  isActive ? 'text-accent-400' : 'text-primary-100 hover:text-background-50 hover:bg-primary-800'
                }`
              }
            >
              关于我们
            </NavLink>
          </nav>

          <form onSubmit={handleSearch} className="hidden md:flex items-center flex-1 max-w-sm ml-auto">
            <div className="relative w-full">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-primary-200 text-sm"></i>
              <input
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                type="search"
                name="q"
                placeholder="搜索动画、游戏、影视片段…"
                className="w-full h-9 pl-9 pr-3 rounded-full bg-primary-950/50 border border-primary-700 text-sm text-background-50 placeholder:text-primary-300 focus:outline-none focus:border-accent-400"
              />
            </div>
          </form>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((open) => !open)}
            className="md:hidden flex items-center justify-center w-9 h-9 rounded-md text-background-50 hover:bg-primary-800 cursor-pointer ml-auto"
          >
            <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-primary-800 bg-primary-900 px-4 py-4 animate-fade-in">
          <form onSubmit={handleSearch} className="relative mb-3">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-primary-200 text-sm"></i>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              type="search"
              name="q"
              placeholder="搜索视频…"
              className="w-full h-10 pl-9 pr-3 rounded-full bg-primary-950/50 border border-primary-700 text-sm text-background-50 placeholder:text-primary-300 focus:outline-none focus:border-accent-400"
            />
          </form>
          <div className="flex flex-col gap-1">
            <Link to="/" onClick={closeMenu} className="px-3 py-2.5 rounded-md text-sm font-medium text-primary-100 hover:bg-primary-800 cursor-pointer">
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={closeMenu}
                className="px-3 py-2.5 rounded-md text-sm font-medium text-primary-100 hover:bg-primary-800 cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" onClick={closeMenu} className="px-3 py-2.5 rounded-md text-sm font-medium text-primary-100 hover:bg-primary-800 cursor-pointer">
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}